import { tokens } from './tokens.js';

// Helpers UI partages : badge, formatage date, etc.

export function Badge({ bg, fg, children, taille = 'normal' }) {
  return (
    <span style={{
      padding: taille === 'petit' ? '1px 6px' : '2px 8px',
      background: bg, color: fg,
      borderRadius: 4,
      fontSize: taille === 'petit' ? 10 : 11,
      fontWeight: 600,
      textTransform: 'uppercase', letterSpacing: 0.3,
      display: 'inline-block',
      lineHeight: 1.4,
      whiteSpace: 'nowrap',
    }}>{children}</span>
  );
}

export function formaterDateRelative(d) {
  if (!d) return '';
  const dt = new Date(d.replace(' ', 'T'));
  const diffMin = Math.floor((Date.now() - dt) / 60000);
  if (diffMin < 1)        return "à l'instant";
  if (diffMin < 60)       return `il y a ${diffMin} min`;
  if (diffMin < 1440)     return `il y a ${Math.floor(diffMin / 60)} h`;
  return dt.toLocaleDateString('fr-FR', { day:'2-digit', month:'short' });
}

export function formaterDateLongue(d) {
  if (!d) return '';
  const dt = new Date(d.replace(' ', 'T'));
  return dt.toLocaleString('fr-FR', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export const boutonPrincipal = {
  display:'inline-flex', alignItems:'center', gap: 6,
  background: tokens.accent, color: 'white',
  border: 'none', padding: '9px 14px', borderRadius: 8,
  fontSize: 14, fontWeight: 600, cursor:'pointer',
};

export const boutonSecondaire = {
  display:'inline-flex', alignItems:'center', gap: 6,
  background: 'transparent',
  color: tokens.inkSoft,
  border: `1px solid ${tokens.border}`,
  padding: '8px 13px', borderRadius: 8,
  fontSize: 13, fontWeight: 500, cursor:'pointer',
};

export const boutonDanger = {
  ...boutonPrincipal,
  background: tokens.danger,
};

export const inputBase = {
  width: '100%',
  padding: '10px 12px',
  border: `1px solid ${tokens.borderStrong}`,
  borderRadius: 6,
  fontSize: 14, outline: 'none',
  fontFamily: 'inherit',
  background: tokens.surface,
};

export const labelChamp = {
  display: 'block', fontSize: 12, fontWeight: 500,
  color: tokens.inkSoft, marginBottom: 6,
};

export function BoiteErreur({ message }) {
  return (
    <div style={{
      marginTop: 14, padding: '10px 12px',
      background: tokens.dangerBg, color: tokens.danger,
      borderRadius: 6, fontSize: 13,
    }}>{message}</div>
  );
}
